module.exports = __webpack_public_path__ + "static/media/mås-min.870f1b2e.png";